import { LinkButton, Header5 } from '@cian/ui-kit';

import * as React from 'react';
import classNames from 'classnames';

import * as styles from './styles.css';

interface IFooterProps {
  className?: string;
}

export const Footer: React.FC<IFooterProps> = ({ className }) => (
  <div className={classNames(styles['root'], className)}>
    <a href="https://promo.cian.ru/coworking" className={styles['link']} target="_blank">
      <Header5 color="primary_100">Узнать больше</Header5>
    </a>
    <LinkButton
      size="XS"
      href="https://www.cian.ru/cat.php?coworking_offer_type%5B0%5D=1&deal_type=rent&engine_version=2&offer_type=offices&office_type%5B0%5D=1&region=1"
    >
      Посмотреть коворкинги
    </LinkButton>
  </div>
);
Footer.displayName = 'Footer';
